<div  *ngIf="!isFetchingIds" class="main-container-view">
    <div class="id-search-container-download">
        <div class="back-search-view">
                <div class="back-btn-view">
                    <img (click)="onBackArrowClick()" src="../../assets/img/tc-back-arrow.png" alt="">
                    <div class="service-info">
                     #{{serviceId}}
                </div>
                </div>
                

                <div class="search-id">
                    <span class="search-icon-id"><i class="ri-search-2-line"></i></span>
                    <input [placeholder]="'search' | translate" class="search-id-input" type="text" name="" id=""  [(ngModel)]="searchData">
                </div>
        </div>
        <div class="email-download-btn">
            <button class="email-btn" (click)="openPopUpForEmailSend()">{{'email' | translate}}</button>
            <button class="download-btn-id" (click)="downloadTemplateForEdit()">{{'download' | translate}}</button>
        </div>
    </div>


    <div class="view-data-id">
        <div *ngFor="let key of filteredIdCardInfo; let index = index" (click)="openPreview(key,index)" class="image-container-for-id">
          <div *ngIf="key.isDuplicate" class="duplicate-container">
            {{'labelDuplicated' | translate}}
          </div>
            <div class="image-sub-container-id-view">
                <img [src]="key.idCardImageUrl" alt="id-card-photo">
            </div>
            <div class="name-container-id-name">
                {{key.studentName}} - {{key.className}} {{key.classNumber}}
            </div>

        </div>
    </div>

     <div *ngIf="openIdPreview" class="modal-overlay" (click)="closeParticularTcPreviewPopup($event)" >
   <img  [ngClass]="{ 'hidden-arrow': currentIndex == 0 }"  src="../../assets/img/tc-left-arrow.svg"
        class="tc-left-arrow tc-arrow" (click)="$event.stopPropagation(); navigateTc(-1);" />
      <div class="tc-preview-modal-content">
        <img [src]="selectedIdCard.idCardImageUrl" class="modal-image-viewer" (click)="$event.stopPropagation();" />
        <div class="tc-download-print-container">
          <img src="../../assets/img/tc-print.svg" class="tc-download-print-element"
            (click)="$event.stopPropagation(); printIdCard()" />
          <img src="../../assets/img/tc-download.svg" class="tc-download-print-element"
            (click)="$event.stopPropagation(); downloadPDFIdCard()" />
        </div>
      </div>
      <img  [ngClass]="{ 'hidden-arrow': currentIndex == idCardInfo.length - 1 }"
        src="../../assets/img/tc-right-arrow.svg" class="tc-right-arrow tc-arrow"
        (click)="$event.stopPropagation(); navigateTc(1);" />

    </div>

    <div
    class="modal fade modal-email-send-main-container"
    id="emailIdDataSent"
    tabindex="-1"
    role="dialog"
    aria-labelledby="simpleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-id-card" role="document">
        <div class="email-send-heading">
            {{'emailSharing' | translate}}
        </div>
        <div class="email-add-container">
            <input [(ngModel)]="emailIdData" type="text" class="email-id-for-id-card-send" [placeholder]="'enterYourEmailId' | translate" />
        </div>
      <div class="button-for-email-id-send">
        <button class="cancel-btn-email-send" (click)="closePopUpForEmailSend()" >{{'cancel' | translate}}</button>
        <button class="proceed-btn-email-send" (click)="sendIdOnEmailId()">
            <span *ngIf="!sendingMail">{{'proceed' | translate}}</span>
            <span *ngIf="sendingMail"><app-button-loader></app-button-loader></span>
            
        </button>
      </div>
    </div>
  </div>

</div>

<div  *ngIf="!isFetchingStaffIds" class="main-container-view">
    <div class="id-search-container-download">
        <div class="back-search-view">
                <div class="back-btn-view">
                    <img (click)="onBackArrowClick()" src="../../assets/img/tc-back-arrow.png" alt="">
                    <div class="service-info">
                     #{{serviceId}}
                </div>
                </div>
                

                <div class="search-id">
                    <span class="search-icon-id"><i class="ri-search-2-line"></i></span>
                    <input [placeholder]="'search' | translate" class="search-id-input" type="text" name="" id=""  [(ngModel)]="searchStaffData">
                </div>
        </div>

        <div class="email-download-btn">
            <button class="email-btn" (click)="openPopUpForEmailSend()">{{'email' | translate}}</button>
            <button class="download-btn-id" (click)="downloadTemplateForEdit()">{{'download' | translate}}</button>
        </div>
    </div>


    <div class="view-data-id">
        <div *ngFor="let key of filteredStaffIdCardInfo; let index = index" (click)="openPreview(key,index)" class="image-container-for-id">
          <div *ngIf="key.isDuplicate" class="duplicate-container">
            {{'labelDuplicated' | translate}}
          </div>
            <div class="image-sub-container-id-view">
                <img [src]="key.idCardImageUrl" alt="id-card-photo">
            </div>
            <div class="name-container-id-name">
                {{key.staffName}}
            </div>

        </div>
    </div>

     <div *ngIf="openIdPreview" class="modal-overlay" (click)="closeParticularTcPreviewPopup($event)" >
   <img  [ngClass]="{ 'hidden-arrow': currentIndex == 0 }"  src="../../assets/img/tc-left-arrow.svg"
        class="tc-left-arrow tc-arrow" (click)="$event.stopPropagation(); navigateTc(-1);" />
      <div class="tc-preview-modal-content">
        <img [src]="selectedIdCard.idCardImageUrl" class="modal-image-viewer" (click)="$event.stopPropagation();" />
        <div class="tc-download-print-container">
          <img src="../../assets/img/tc-print.svg" class="tc-download-print-element"
            (click)="$event.stopPropagation(); printIdCard()" />
          <img src="../../assets/img/tc-download.svg" class="tc-download-print-element"
            (click)="$event.stopPropagation(); downloadStaffPDFIdCard()" />
        </div>
      </div>
      <img  [ngClass]="{ 'hidden-arrow': currentIndex == idCardInfo.length - 1 }"
        src="../../assets/img/tc-right-arrow.svg" class="tc-right-arrow tc-arrow"
        (click)="$event.stopPropagation(); navigateTc(1);" />

    </div>

    <div
    class="modal fade modal-email-send-main-container"
    id="emailIdDataSent"
    tabindex="-1"
    role="dialog"
    aria-labelledby="simpleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-id-card" role="document">
        <div class="email-send-heading">
            {{'emailSharing' | translate}}
        </div>
        <div class="email-add-container">
            <input [(ngModel)]="emailIdData" type="text" class="email-id-for-id-card-send" [placeholder]="'enterYourEmailId' | translate" />
        </div>
      <div class="button-for-email-id-send">
        <button class="cancel-btn-email-send" (click)="closePopUpForEmailSend()" >{{'cancel' | translate}}</button>
        <button class="proceed-btn-email-send" (click)="sendStaffIdOnEmail()">
            <span *ngIf="!sendingMail">{{'proceed' | translate}}</span>
            <span *ngIf="sendingMail"><app-button-loader></app-button-loader></span>
            
        </button>
      </div>
    </div>
  </div>

</div>

<app-new-loader *ngIf="isFetchingIds"></app-new-loader>
<app-new-loader *ngIf="isFetchingStaffIds"></app-new-loader>

